import { action, makeAutoObservable, observable } from "mobx";
import { ChangeEvent } from "react";
import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import { sendProfileApiCall } from "../../api/auth/profileApi";
import { sendSignUpLinkEmailApiCall } from "../../api/auth/sendEmailLinkApi";
import { sendSignUpLinkPhoneApiCall } from "../../api/auth/sendPhoneLinkApi";
import {
  resendOTP,
  sendSignUpApiCallEmail,
  sendSignUpApiCallPhone,
  verifyOTP,
} from "../../api/auth/signupApi";
import { authorizeSignUpApiCall } from "../../api/auth/signupAuthApi";
import { ProfileModel } from "../../datamodels/auth/profileModel";
import { SignupAuthModel } from "../../datamodels/auth/signupAuthModel";
import { DefaultModel } from "../../datamodels/onboarding/defaultModel";

class SignUpViewModel {
  constructor() {
    makeAutoObservable(this);
  }
  @observable public usernameField: string = "";
  @observable public emailField: string = "";
  @observable public passwordField: string = "";
  @observable public selectedCountry: string = "";
  @observable public isoAreaCode: string = "";
  @observable public phoneNumber: string = "";
  @observable public phoneLogin: boolean = false;
  @observable public signupErrorMessage: string = "";
  @observable public isShowingOtp: boolean = false;

  @observable public otpField: string = "";
  @observable public otpProfileId: string = "";
  @observable public otperrormsg: string = "";

  @action handleEmailButton = () => {
    this.phoneLogin = false;
  };

  @action handlePhoneButton = () => {
    this.phoneLogin = true;
  };

  @action handleUsernameChange = (event: ChangeEvent): void => {
    const element = event.currentTarget as HTMLInputElement;
    this.usernameField = element.value;
  };

  @observable public country: string = "";

  @action handlePhoneNumberChange = (value?: string): void => {
    if (value !== undefined) {
      this.country = parsePhoneNumber(value!)?.country!;
      this.phoneNumber = value;
      console.log(this.phoneNumber);
    } else {
      this.phoneNumber = "";
    }
  };

  @action handlePasswordChange = (event: ChangeEvent): void => {
    const element = event.currentTarget as HTMLInputElement;
    this.passwordField = element.value;
  };

  @action handleEmailChange = (event: ChangeEvent): void => {
    const element = event.currentTarget as HTMLInputElement;
    this.emailField = element.value;
  };

  @action handleOTPChange = (value: string): void => {
    this.otpField = value;
  };

  @action handleCountryChange = (newCountry: string): void => {
    console.log(newCountry);
  };

  // @action signup = async (): Promise<void> => {
  //   this.isShowingOtp = true;
  // if (this.phoneLogin === false) {
  //   if (this.usernameField && this.passwordField && this.emailField) {
  //     const response = await sendSignUpApiCallEmail(
  //       null,
  //       this.emailField,
  //       null
  //     );
  //     if (response.responseInfo.httpCode === 200) {
  //       this.startCountdown();
  //       this.isShowingOtp = true;
  //       this.otpProfileId = response.data.profileId!;
  //       // this.router.push("/login");
  //     } else {
  //       alert(response.responseInfo.message);

  //       this.signupErrorMessage = response.responseInfo.message;
  //     }
  //   } else {
  //     this.signupErrorMessage = "Check Your Details";
  //   }
  // }
  // else {
  //   if (this.usernameField && this.passwordField && this.phoneNumber) {
  //     if (isValidPhoneNumber(this.phoneNumber) === true) {
  //       let countryCallingCode =
  //         "+" +
  //         parsePhoneNumber(this.phoneNumber)?.countryCallingCode.toString();
  //       let number = this.phoneNumber.replace(countryCallingCode, "");
  //       let country = parsePhoneNumber(this.phoneNumber)?.country;
  //       console.log(number + " " + country);
  //       const response = await sendSignUpApiCallPhone(
  //         number,
  //         null,
  //         null,
  //         country
  //       );
  //       console.log(response);
  //       if (response.responseInfo.httpCode === 200) {
  //         this.startCountdown();

  //         this.isShowingOtp = true;
  //         this.otpProfileId = response.data.profileId!;
  //       } else {
  //         this.signupErrorMessage = response.responseInfo.message;
  //       }
  //     } else {
  //       this.signupErrorMessage = "Invalid Phone Number";
  //     }
  //   } else {
  //     this.signupErrorMessage = "Check Your Details";
  //   }
  // }
  // };

  //send signup link
  @observable public goToVerify: boolean = false;
  @observable public emailLinkResp: DefaultModel | undefined;
  @observable public phoneLinkResp: DefaultModel | undefined;

  @action signup = async (): Promise<void> => {
    if (this.phoneLogin) {
      if (isValidPhoneNumber(this.phoneNumber) === true) {
        let countryCallingCode =
          "+" +
          parsePhoneNumber(this.phoneNumber)?.countryCallingCode.toString();
        this.phoneNumber = this.phoneNumber.replace(countryCallingCode, "");
        const response = await sendSignUpApiCallPhone(
          this.phoneNumber,
          this.country
        );
        console.log(response);
        if (response.responseInfo.httpCode === 200) {
          this.startCountdown();
          this.isShowingOtp = true;
          this.otpProfileId = response.data.profileId!;
        } else {
          this.signupErrorMessage = response.responseInfo.message;
        }
      } else {
        this.signupErrorMessage = "Invalid Phone Number";
      }
    } else {
      this.emailLinkResp = await sendSignUpLinkEmailApiCall(this.emailField);
      if (this.emailLinkResp.responseInfo.httpCode === 200) {
        this.goToVerify = true;
      } else {
        this.signupErrorMessage = this.emailLinkResp.responseInfo.message;
      }
    }
  };

  //Authorization
  @observable public queryToken: string | null | undefined;
  @observable public signupAuth: SignupAuthModel | undefined;
  @observable public JWTToken: string = "";

  @action authorizeSignup = async (): Promise<void> => {
    this.signupAuth = await authorizeSignUpApiCall(this.queryToken!);
    if (this.signupAuth.responseInfo.httpCode === 200) {
      this.changeJwtToken(this.signupAuth.data.accessToken);
      this.changeJwtTokenType(this.signupAuth.data.tokenType);
      this.getProfile(localStorage.getItem("@JWTToken")!);
      this.JWTToken = localStorage.getItem("@JWTToken")!;
      localStorage.setItem("isLoggedIn", "yes");
    }
  };

  //Get profile
  @action changeJwtToken = (newJwtToken: string) => {
    localStorage.setItem("@JWTToken", newJwtToken);
  };

  @action changeJwtTokenType = (newJwtTokenType: string) => {
    localStorage.setItem("@JWTTokenType", newJwtTokenType);
  };

  @action changeUserId = (newUserId: number) => {
    localStorage.setItem("@UserId", newUserId.toString());
  };

  @observable public profileResponse: ProfileModel | undefined;
  @observable public username: string = "";
  @observable public userId: number | undefined;

  @action async getProfile(JWTToken: string) {
    this.profileResponse = await sendProfileApiCall(
      "Bearer",
      localStorage.getItem("@JWTToken")!
    );
    if (this.profileResponse.responseInfo.httpCode === 200) {
      this.changeUserId(this.profileResponse.data.userId);
      this.username = this.profileResponse.data.userName;
      this.userId = this.profileResponse.data.userId;
      console.log(this.profileResponse.data);
    }
  }

  @action OTPViewInit = () => {
    console.log(localStorage.getItem("didOTP"));
    this.otperrormsg = "";
    if (
      localStorage.getItem("didOTP") ||
      localStorage.getItem("didOTP") === "false"
    ) {
      this.otpProfileId = localStorage.getItem("profileId")!;
    } else {
      //   this.router.push("/");
    }
  };

  @observable public goToStart: boolean = false;

  @action verifyOTP = async (): Promise<void> => {
    const resp = await verifyOTP(this.otpField, this.otpProfileId);
    console.log(resp);
    if (resp.responseInfo.httpCode === 200) {
      this.isShowingOtp = false;
      this.goToStart = true;
      this.changeJwtToken(resp.data.accessToken);
      this.changeJwtTokenType(resp.data.tokenType);
      this.getProfile(localStorage.getItem("@JWTToken")!);
      this.JWTToken = localStorage.getItem("@JWTToken")!;
      localStorage.setItem("isLoggedIn", "yes");
      //   this.router.push("/login");
    } else {
      this.otperrormsg = resp.responseInfo.message;
    }
  };

  @action resendOTP = async (): Promise<void> => {
    const resp = await resendOTP(this.otpProfileId);
    this.otperrormsg = resp.responseInfo.message;
  };

  @observable public seconds: number = 300;
  @observable public countdownTime: string = "5:00";
  @observable public resendOtpEnabled: boolean = false;

  @action startCountdown = (): void => {
    this.resendOtpEnabled = false;
    this.seconds = 300;
    this.tick();
  };

  @action tick = (): void => {
    this.seconds--;
    this.calculateTime();
    if (this.seconds > 0) {
      setTimeout(this.tick, 1000);
    } else {
      this.resendOtpEnabled = true;
    }
  };

  @action calculateTime = (): void => {
    this.countdownTime =
      Math.floor(this.seconds / 60) +
      ":" +
      ("0" + Math.floor(this.seconds % 60)).slice(-2);
  };
}

export default SignUpViewModel;
